import { apiClient } from '@/api'

export default {
  namespaced: true,
  state: () => ({
    roles: []
  }),
  actions: {
    async fetchRoles({ commit, rootState }) {
      const res = await apiClient('roles.get', { account_id: rootState.account_id });
      if(res?.list){
        commit('SET_ROLES', res.list);
      }
    },
    async createRole({ rootState }, payload) {
      await apiClient('roles.create', {
        ...payload,
        account_id: rootState.account_id
      })
    },
    async updateRole({ dispatch, rootState }, payload) {
      await apiClient('roles.update', {
        ...payload,
        account_id: rootState.account_id
      })
      dispatch('fetchRoles')
    },
    async deleteRole({ dispatch, rootState }, id) {
      await apiClient('roles.delete', {
        id: id,
        account_id: rootState.account_id
      })
      dispatch('fetchRoles')
    }
  },
  mutations: {
    SET_ROLES(state, roles) {
      state.roles = roles
    }
  },
  getters:{
    roles: state => state.roles
  }
}